import { render, staticRenderFns } from "./OnlineStore.vue?vue&type=template&id=1fa1fb31&"
import script from "./OnlineStore.vue?vue&type=script&lang=js&"
export * from "./OnlineStore.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStore.vue?vue&type=style&index=0&id=1fa1fb31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports